import React, { useEffect, useState, useRef } from "react";
import "../portfolio.css";
import UnauthorizedNavbar from "./unauthorizedNavbar";
import UnauthorizedFooter from "./unauthorizedFooter";
import { FaGooglePlay, FaApple } from "react-icons/fa";

const Portfolios = () => {
 const [faqs, setFaqs] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
   const BASE_URL = process.env.REACT_APP_BASE_URL;
   const downloadRef = useRef(null);



  useEffect(() => {
    fetch(`${BASE_URL}/home/strategy/strategyDetailsWithTitle`)
      .then((res) => res.json())
      .then((data) => {
        let all = data?.data?.strategies || [];
        setStrategies(all);
      });
  }, []);

  useEffect(() => {
     fetch(`${BASE_URL}/fetchActiveQueAns`)
      .then((res) => res.json())
      .then((response) => {
        if (response?.data) {
          const homepageFaqs = response.data.filter(
            (item) => item.section === "portfolio"
          );
  
          setFaqs(homepageFaqs);
        }
      })
      .catch((err) => console.error("FAQ Fetch Error:", err));
  }, []);

  
const handleScroll = () => {
  if (downloadRef.current) {
    downloadRef.current.scrollIntoView({ behavior: "smooth" });
  }
}

  const handleSubscribe = (store) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      if (store === "android") {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.bossinvestor.app";
      } else if (store === "ios") {
        window.location.href =
          "https://apps.apple.com/us/app/example-app/id123456789"; // replace with real ID
      }
    } else {
      setShowPopup(true);
    }
  };

  const portfolioDetails = {
  "Quant Momentum": {
    type: "Momentum",
    cycle: "Monthly",
    longDescription: `
      <p><strong>The Trend Specialist</strong></p>
      <ul>
        <li><strong>Strategy:</strong> Active trend and quality capture targeting the fastest-moving institutional-grade stocks.</li>
        <li><strong>Core Logic:</strong> Utilizes a price Momentum filter paired with financial acceleration to capture the optimal growth phase of a trend.</li>
        <li><strong>Ideal For:</strong> Aggressive investors seeking high-velocity growth with monthly agility to adapt to shifting trends.</li>
      </ul>
    `
  },

  "Quant Compounding": {
    type: "Growth",
    cycle: "Quarterly",
    longDescription: `
      <p><strong>The Structural Wealth Engine</strong></p>
      <ul>
        <li><strong>Strategy:</strong> Focuses on the top dominant industry leaders with resilient margins and established compounding power.</li>
        <li><strong>Core Logic:</strong> Built on the Consistent Compounding (CCP) pillar to maximize long-term stability and minimize market noise.</li>
        <li><strong>Ideal For:</strong> Patient investors looking for market leadership and reduced portfolio turnover.</li>
      </ul>
    `
  },

  "Focus360 Velocity": {
    type: "Multi-Asset",
    cycle: "Monthly",
    longDescription: `
      <p><strong>Hyper-Growth & Global Defense</strong></p>
      <ul>
        <li><strong>Strategy:</strong> Targets high-conviction companies in the fastest lane of expansion with revenue and profit growth.</li>
        <li><strong>Core Logic:</strong> Includes a tactical pivot to Gold and Nasdaq ETFs to protect capital when domestic market breadth weakens.</li>
        <li><strong>Ideal For:</strong> Growth-focused investors who want aggressive upside backed by a macro-aware safety net.</li>
      </ul>
    `
  },

  "Focus360 Ascend": {
    type: "Low Volatility",
    cycle: "Quarterly",
    longDescription: `
      <p><strong>Disciplined Tactical Momentum</strong></p>
      <ul>
        <li><strong>Strategy:</strong> High-velocity momentum approach with a strict margin-of-safety requirement.</li>
        <li><strong>Core Logic:</strong> Limits entries to stocks with low PE and uses defensive stabilizers for risk management.</li>
        <li><strong>Ideal For:</strong> Value-conscious investors who demand tactical strength without overpaying for growth.</li>
      </ul>
    `
  }
};


  const formatMonthYear = (dateStr) => {
    if (!dateStr) return "--";
    const date = new Date(dateStr);
    return date.toLocaleString("en-US", {
      month: "short",
      year: "2-digit"
    });
  };

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


  return (
    <>
      <UnauthorizedNavbar />

      <div className="mp-wrapper" style={{background: 'linear-gradient(to bottom right, #f1e8f7, #fdf4e7'}}>
        <header className="header-section">
          <h1 className="header-title">
            Beat the Market with Data-Driven <br className="hide-md" />
            <span className="text-brand-gradient">Model Portfolios</span>
          </h1>
          <p className="header-subtitle">
            Automate your wealth creation with India’s top-rated model portfolio app.
          </p>
        </header>

        <section className="cards-section">
          {strategies.map((item, index) => {

            const xirr = item.data?.xirr || 0;
            const totalReturn = item.data?.netReturns || 0;
            const stats = item.data?.strategyHighlights;
            const rawFeatures = item.features;          // this is a string
            const featureArray = JSON.parse(rawFeatures);   // convert string → array

            const rebalance = featureArray.find(f =>
              f.toLowerCase().includes("rebalance")
            )?.replace(/rebalance/i, "").trim() || "";

            const minInv = featureArray.find(f =>
              f.toLowerCase().includes("min invest")
            )?.replace(/min invest/i, "").trim() || "";



            return (
              <div
                key={index}
                className="portfolio-page-card"
                style={{ animationDelay: `${0.3 + index * 0.2}s` }}
              >
                <div className="top-strip"></div>

                <div className="card-body">
                  <div className="card-header">
                    <div className="card-header-left">
                      <div className="icon-box purple">
                        <img src={item.iconURL} alt={item.title} className="portfolio-icon" />
                      </div>
                      <div>
                        <h3 className="card-title">{item.title}</h3>
                        <div className="badge-row">
                          <span className="badge purple-badge rounded-full">
                            {portfolioDetails[item.title]?.type}
                          </span>

                          <span className="badge orange-badge rounded-full">
                            {portfolioDetails[item.title]?.cycle}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="portfolio-card-desc">
                    {portfolioDetails[item.title]?.description}
                  </p>
                  <div className="info-row">
                    <div>
                      <i className="fas fa-sync-alt text-brandOrange"></i> Rebalance:
                      <span className="rebalancespan">{rebalance}</span>
                    </div>

                    <div>
                      <i className="fas fa-wallet text-brandOrange"></i> Min Inv:
                      <span className="rebalancespan">₹{minInv}</span>
                    </div>

                    <div className="download-link">
                      <a href={stats.strategyDetails} target="_blank" rel="noopener noreferrer" download>
                        <i className="fas fa-download download-icon"></i>
                        <span>Methodology</span>
                      </a>
                    </div>
                  </div>

                  {item.showBacktestPerformance ? (
                  <div className="stats-box">
                    <h4 className="stats-title">Historical Backtested Performance</h4>

                    <div className="stats-grid">

                      <div>
                        <p className="label">CAGR</p>
                        <p className="stat-value orange-text">{xirr}%</p>
                      </div>

                      <div>
                        <p className="label">₹1 lakh invested for 5 years could be</p>
                        <p className="stat-value-dark">
                          ₹{Math.round(totalReturn).toLocaleString("en-IN")}
                        </p>

                      </div>

                      <div className="stats-inner-grid">
                        <div>
                          <p className="label-xs">Win Rate</p>
                          <p className="stat-dark">
                            {stats?.winningTrades + stats?.losingTrades > 0 ? (
                              <>
                                <span style={{ color: "#1f2937", fontWeight: "700" }}>
                                  {Math.round((stats?.winningTrades / stats?.totalTrades) * 100)}%
                                </span>
                                <span style={{ color: "#92959aff", marginLeft: "4px" , fontSize:'13px', fontWeight: "400"}}>
                                  ({stats?.winningTrades}/{stats?.totalTrades})
                                </span>
                              </>
                            ) : (
                              "--"
                            )}
                          </p>
                        </div>

                        <div>
                          <p className="label-xs">Total Trades</p>
                          <p className="stat-dark">{stats?.totalTrades}</p>
                        </div>

                        <div>
                          <p className="label-xs">Max DD</p>
                          <p className="stat-red">{item.data?.drawdown?.drawDownInPercentage}%</p>
                        </div>

                        <div>
                          <p className="label-xs">Avg Win</p>
                          <p className="stat-dark">{stats?.averageWinningTrades?.toFixed(2)}%</p>
                        </div>

                        <div>
                          <p className="label-xs">Avg Loss</p>
                          <p className="stat-dark">{stats?.averageLosingTrades?.toFixed(2)}%</p>
                        </div>

                        <div>
                          <p className="label-xs">DD Period</p>
                          <p className="stat-dark ">
                            {formatMonthYear(item.data?.drawdown?.startRange)} –{" "}
                            {formatMonthYear(item.data?.drawdown?.endRange)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  ) : (
                   <div className="stats-box"> 
                  <div
                    className="long-description"
                    dangerouslySetInnerHTML={{
                      __html: portfolioDetails[item.title]?.longDescription || "",
                    }}
                  />
                  </div>
                )}

                 <button className="subscribe-btn" onClick={handleScroll}>
                  Subscribe Now <i className="fas fa-arrow-right ml"></i>
                </button>
                </div>
              </div>
            );
          })}

        </section>

        <section className="download-section" ref={downloadRef}>
          <div className="blur-circle top-right"></div>
          <div className="blur-circle bottom-left"></div>
          <div className="download-container">
            <h2 className="download-title">
              Your Pocket Investing App<br />
              <span className="highlight">Download BossInvestor</span>
            </h2>
            <p className="download-text">
              Unlock exclusive strategy templates, Model Portfolios, and get instant
              rebalancing updates on the go.
            </p>
            <div className="download-buttons">
              <button
                className="download-btn"
                onClick={() => handleSubscribe("android")}
              >
                <FaGooglePlay className="icon" />
                Google Play
              </button>

              <button
                className="download-btn"
                onClick={() => handleSubscribe("ios")}
              >
                <FaApple className="icon" />
                App Store
              </button>
            </div>
          </div>
        </section>

        <section className="portfolio-faq-section" style={{paddingTop : '50px', marginBottom:'0px !important',background: 'linear-gradient(to bottom right, #f1e8f7, #fdf4e7'}}>
          <div className="container">
            <h2 className="faq-title">Frequently Asked Questions</h2>
              <div className="faq-list">
                {faqs.map((faq, index) => (
                  <div key={faq.id} className="faq-item">
                    <button
                      className="faq-question"
                      onClick={() => toggleFaq(index)}
                    >
                      <span>{faq.question}</span>
                      <svg
                        className={`faq-icon ${openIndex === index ? "open" : ""}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        ></path>
                      </svg>
                    </button>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                ))}
              </div>
          </div>
        </section>

      </div>
      {showPopup && (
        <div className="qr-overlay" onClick={() => setShowPopup(false)}>
          
          <div className="qr-modal" onClick={(e) => e.stopPropagation()}>

            <button className="qr-close-icon" onClick={() => setShowPopup(false)}>
              ✕
            </button>

            <h2 className="qr-title">Get the Bossinvestor App</h2>
            <img 
              src="/playstoreScanner.jpeg" 
              alt="QR Code" 
              style={{ width: "170px", height: "170px", borderRadius: "12px" }}
            />
            <p className="qr-subtitle">
              Scan the QR code to download the app
            </p>

          </div>
        </div>
      )}


      <UnauthorizedFooter />
    </>
  );
};

export default Portfolios;
